// @ts-nocheck

import { find, mapValues, reduce, values, some } from 'lodash';

import { BasketModes, BasketStatuses, BasketItemStatuses } from '../../../types/basket';

/**
 * Return the nextState corresponding to the
 * BASKET_VALIDATE_ITEMS action
 *
 * @static
 * @param  {Object} state  The actual state
 * @param  {Object} action The action to reduce
 * @return {Object}        Return the new state.
 */
const basketValidateItems = (state, action) => {
  const { items, mode, traderId: betslipTraderId } = state;
  const { betList, betslipId, additionalMessage, traderId } = action.payload;

  // is this validation still relevant for the current betslip ?
  if (
    !traderId ||
    (mode === BasketModes.SIMPLE && some(values(items), { traderId })) ||
    (mode !== BasketModes.SIMPLE && traderId === betslipTraderId)
  ) {
    const nextItems = mapValues(items, (item) => {
      // betList items attributes :
      // r -> reference for betbuilder item
      // o -> value in thousandth
      // bid -> outcome id
      const betListItem = find(betList, ({ r, bid }) => item.oddId === r || item.oddId === bid);
      if (mode !== BasketModes.SIMPLE || betListItem) {
        return {
          ...item,
          ...(betListItem && { validatedValue: parseFloat(betListItem.o / 1000) }),
          status: BasketItemStatuses.VALIDATED,
          betslipId,
          additionalMessage,
          error: undefined,
        };
      }
      return item;
    });

    const nextStatus = reduce(
      nextItems,
      (finalStatus, currentItem) => {
        if (mode === BasketModes.SIMPLE) {
          if (currentItem.status === BasketItemStatuses.ERROR && finalStatus !== BasketStatuses.PENDING) {
            return BasketStatuses.OK;
          }
        }
        if (currentItem.status === BasketItemStatuses.PENDING && !currentItem.cashout) {
          return BasketStatuses.PENDING;
        }
        return finalStatus;
      },
      BasketStatuses.VALIDATED,
    );

    return {
      ...state,
      items: nextItems,
      status: nextStatus,
      betslipId,
      additionalMessage,
      ...(nextStatus === BasketStatuses.VALIDATED && {
        error: undefined,
        isCashout: false,
      }),
    };
  }

  return state;
};

export default basketValidateItems;
